(window.URL = "https://shark-app-hwull-vatwr.ondigitalocean.app/"),
  $(window).on("load", function () {
    $("#tree").treed();
    var i = window.location.pathname;
    $("#tree li a").each(function () {
      var t = $(this).attr("href");
      window.location.pathname.indexOf(t) > -1 &&
        ($(this).parent().addClass("active"),
        $(this).parent().children("ul").children("li").show(),
        $(this).parent().parents("li").addClass("parent"),
        $(this).parent().parents("li").children("ul").children("li").show());
    }),
      $("[data-app-toggle]").on("click", function (t) {
        var a = $(this).attr("data-app-target");
        
        switch (a) {
          case "classic":
            window.location.href = window.location.origin + "/collections/classic-course"
            break;
          case "classic-enhanced-course":
              window.location.href = window.location.origin + "/collections/advanced-classic-course"
              break;
          case "volume-course":
            window.location.href = window.location.origin + "/collections/volume-course"
            break;
          case "volume-enhanced-course":
            window.location.href = window.location.origin + "/collections/advanced-volume-course"
            break;
          case "classic-mastery-course":
            window.location.href = window.location.origin + "/collections/mastery-classic-course"
            break;
          case "volume-mastery-course":
            window.location.href = window.location.origin + "/collections/mastery-volume-course"
            break;
          default:
              break;
        }
      });
  });
//# sourceMappingURL=/s/files/1/0668/2355/3337/t/2/assets/app.js.map?v=1671804407


$(window).on("load", function () {
  var url = window.location.pathname;
  var filename = url.substring(url.lastIndexOf('/')+1);

  var customerId = __st.cid;

  switch (filename) {
    case "classic":
      tagName = "viewed_classic"
      window.localStorage.setItem("tagName",tagName)
      break;
    case "classic-enhanced":
      tagName = "viewed_enhancedclassic"
      window.localStorage.setItem("tagName",tagName)
        break;
    case "volume":
      tagName = "viewed_volume"
      window.localStorage.setItem("tagName",tagName)
      break;
    case "volume-enhanced":
      tagName = "viewed_enhancedvolume"
      window.localStorage.setItem("tagName",tagName)
      break;
    default:
        break;
      }
function updateCustomerTags() {
  
  var settings = {
    "url": window.URL+ "api/customer/tags",
    "method": "POST",
    "timeout": 0,
    "headers": {
      "Content-Type": "application/json"
    },
    "data": JSON.stringify({
      "userId": customerId,
      "tags": tagName
    }),
  };
  
  $.ajax(settings).done(function (response) {
    console.log("customerTags",response);
  });
}



});
